import type { QueryClient } from '@tanstack/react-query';

/**
 * Referência global ao QueryClient do app para código FORA da árvore React
 * (ex.: o linkedinJobTracker, que resolve desfechos de envio em background e
 * precisa invalidar o board de cadências na hora — sem esperar o próximo
 * refetch). Registrada uma única vez pelo App na inicialização.
 */
let ref: QueryClient | null = null;

export const setQueryClient = (client: QueryClient): void => {
  ref = client;
};

export const getQueryClient = (): QueryClient | null => ref;
